import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

axios.defaults.withCredentials = true;

export const api = {
  changePassword: (currentPassword, newPassword) => 
    axios.post(`${API}/auth/change-password`, { current_password: currentPassword, new_password: newPassword }).then(r => r.data),
  forgotPassword: (email) =>
    axios.post(`${API}/auth/forgot-password`, { email }).then(r => r.data),
  resetPassword: (email, code, newPassword) =>
    axios.post(`${API}/auth/reset-password`, { email, code, new_password: newPassword }).then(r => r.data),

  updateProfile: (data) => axios.patch(`${API}/profile`, data).then(r => r.data),
  getPublicProfiles: () => axios.get(`${API}/profile/public`).then(r => r.data),
  getUserProfile: (userId) => axios.get(`${API}/profile/${userId}`).then(r => r.data),
  getCountries: () => axios.get(`${API}/countries`).then(r => r.data),
  getHousemates: () => axios.get(`${API}/housemates`).then(r => r.data),
  getNewGuests: (since = 7) => axios.get(`${API}/community/new-guests`, { params: { since } }).then(r => r.data),

  getClaims: () => axios.get(`${API}/claims`).then(r => r.data),
  createClaim: (data) => axios.post(`${API}/claims`, data).then(r => r.data),
  updateClaim: (id, data) => axios.patch(`${API}/claims/${id}`, data).then(r => r.data),
  getClaimMessages: (id) => axios.get(`${API}/claims/${id}/messages`).then(r => r.data),
  postClaimMessage: (id, text) => axios.post(`${API}/claims/${id}/messages`, { text }).then(r => r.data),
  markClaimRead: (id) => axios.post(`${API}/claims/${id}/read`).then(r => r.data),

  requestContractRenewal: (data) => axios.post(`${API}/contract-renewals`, data).then(r => r.data),
  getContractRenewals: () => axios.get(`${API}/contract-renewals`).then(r => r.data),
  updateContractRenewal: (id, data) => axios.patch(`${API}/contract-renewals/${id}`, data).then(r => r.data),

  getAnnouncements: () => axios.get(`${API}/announcements`).then(r => r.data),
  createAnnouncement: (data) => axios.post(`${API}/announcements`, data).then(r => r.data),
  updateAnnouncement: (id, data) => axios.patch(`${API}/announcements/${id}`, data).then(r => r.data),
  deleteAnnouncement: (id) => axios.delete(`${API}/announcements/${id}`).then(r => r.data),
  markAnnouncementRead: (id) => axios.post(`${API}/announcements/${id}/read`).then(r => r.data),
  markAllAnnouncementsRead: () => axios.post(`${API}/announcements/read-all`).then(r => r.data),
  getSettings: () => axios.get(`${API}/settings`).then(r => r.data),
  updateSettings: (data) => axios.patch(`${API}/settings`, data).then(r => r.data),

  listDirectThreads: () => axios.get(`${API}/direct-messages/threads`).then(r => r.data),
  createDirectThread: (guest_user_id) => axios.post(`${API}/direct-messages/threads`, { guest_user_id }).then(r => r.data),
  listDirectMessages: (threadId) => axios.get(`${API}/direct-messages/threads/${threadId}/messages`).then(r => r.data),
  sendDirectMessage: (threadId, text, imageUrl) => axios.post(
    `${API}/direct-messages/threads/${threadId}/messages`,
    imageUrl ? { text, image_url: imageUrl } : { text },
  ).then(r => r.data),
  markDirectThreadRead: (threadId) => axios.post(`${API}/direct-messages/threads/${threadId}/read`).then(r => r.data),
  markDirectThreadUnread: (threadId) => axios.post(`${API}/direct-messages/threads/${threadId}/unread`).then(r => r.data),

  getHouses: () => axios.get(`${API}/houses`).then(r => r.data),
  createHouse: (data) => axios.post(`${API}/houses`, data).then(r => r.data),
  updateHouse: (id, data) => axios.patch(`${API}/houses/${id}`, data).then(r => r.data),
  deleteHouse: (id) => axios.delete(`${API}/houses/${id}`).then(r => r.data),
  getHouseRoomsAvailability: (id) => axios.get(`${API}/houses/${id}/rooms-availability`).then(r => r.data),

  getUsers: () => axios.get(`${API}/users`).then(r => r.data),
  createUser: (data) => axios.post(`${API}/users`, data).then(r => r.data),
  updateUser: (id, data) => axios.patch(`${API}/users/${id}`, data).then(r => r.data),
  deleteUser: (id) => axios.delete(`${API}/users/${id}`).then(r => r.data),
  resetUserPassword: (id) => axios.post(`${API}/users/${id}/reset-password`).then(r => r.data),

  getBenefits: () => axios.get(`${API}/benefits`).then(r => r.data),
  createBenefit: (data) => axios.post(`${API}/benefits`, data).then(r => r.data),
  updateBenefit: (id, data) => axios.patch(`${API}/benefits/${id}`, data).then(r => r.data),
  deleteBenefit: (id) => axios.delete(`${API}/benefits/${id}`).then(r => r.data),
  reorderBenefits: (orderedIds) => axios.post(`${API}/benefits/reorder`, { order: orderedIds }).then(r => r.data),

  getVisits: () => axios.get(`${API}/visits`).then(r => r.data),
  createVisit: (data) => axios.post(`${API}/visits`, data).then(r => r.data),
  respondToVisit: (id, data) => axios.patch(`${API}/visits/${id}`, data).then(r => r.data),

  getTransfers: () => axios.get(`${API}/transfers`).then(r => r.data),
  createTransfer: (data) => axios.post(`${API}/transfers`, data).then(r => r.data),
  respondToTransfer: (id, data) => axios.patch(`${API}/transfers/${id}`, data).then(r => r.data),

  getStats: () => axios.get(`${API}/stats`).then(r => r.data),
  getStatsExtended: () => axios.get(`${API}/stats/extended`).then(r => r.data),
  getAnalytics: () => axios.get(`${API}/analytics`).then(r => r.data),
  getOccupancy: () => axios.get(`${API}/occupancy`).then(r => r.data),

  getEvents: () => axios.get(`${API}/events`).then(r => r.data),
  createEvent: (data) => axios.post(`${API}/events`, data).then(r => r.data),
  toggleEventAttendance: (id) => axios.post(`${API}/events/${id}/attend`).then(r => r.data),
  deleteEvent: (id) => axios.delete(`${API}/events/${id}`).then(r => r.data),

  setQuickActions: (actions) => axios.put(`${API}/me/quick-actions`, { quick_actions: actions }).then(r => r.data),
  markSeen: (data) => axios.post(`${API}/me/seen`, data).then(r => r.data),
  markOnboardingSeen: () => axios.post(`${API}/me/onboarding-seen`).then(r => r.data),
  dismissWelcomeBanner: () => axios.post(`${API}/me/welcome-banner-dismissed`).then(r => r.data),

  getSpaces: () => axios.get(`${API}/spaces`).then(r => r.data),
  createSpace: (data) => axios.post(`${API}/spaces`, data).then(r => r.data),
  updateSpace: (id, data) => axios.patch(`${API}/spaces/${id}`, data).then(r => r.data),
  deleteSpace: (id) => axios.delete(`${API}/spaces/${id}`).then(r => r.data),
  getReservations: (params = {}) => axios.get(`${API}/reservations`, { params }).then(r => r.data),
  createReservation: (data) => axios.post(`${API}/reservations`, data).then(r => r.data),
  cancelReservation: (id) => axios.delete(`${API}/reservations/${id}`).then(r => r.data),
  updateReservation: (id, data) => axios.patch(`${API}/reservations/${id}`, data).then(r => r.data),
  cancelVisit: (id) => axios.delete(`${API}/visits/${id}`).then(r => r.data),
  testPushNotification: () => axios.post(`${API}/push/test`).then(r => r.data),

  sendPushNotification: (title, message, targetUsers = []) => 
    axios.post(`${API}/push/send`, { title, message, target_users: targetUsers }).then(r => r.data),
  testPush: () => axios.post(`${API}/push/test`).then(r => r.data),

  benefitRedeemToken: (benefitId) => axios.post(`${API}/benefits/${benefitId}/redeem-token`).then(r => r.data),
  benefitVerify: (token) => axios.get(`${API}/redeem/verify/${token}`).then(r => r.data),

  getSurveys: () => axios.get(`${API}/surveys`).then(r => r.data),
  createSurvey: (data) => axios.post(`${API}/surveys`, data).then(r => r.data),
  updateSurvey: (id, data) => axios.patch(`${API}/surveys/${id}`, data).then(r => r.data),
  deleteSurvey: (id) => axios.delete(`${API}/surveys/${id}`).then(r => r.data),
  getActiveSurvey: () => axios.get(`${API}/surveys/active`).then(r => r.data),
  submitSurveyResponse: (id, data) => axios.post(`${API}/surveys/${id}/responses`, data).then(r => r.data),
  getSurveyMetrics: (id) => axios.get(`${API}/surveys/${id}/metrics`).then(r => r.data),
  getSurveyResponses: (id) => axios.get(`${API}/surveys/${id}/responses`).then(r => r.data),
  getSurveysDashboard: (params = {}) => axios.get(`${API}/surveys/dashboard`, { params }).then(r => r.data),
  getSurveyRaffle: (id) => axios.get(`${API}/surveys/${id}/raffle`).then(r => r.data),
  runSurveyRaffle: (id, force = false) => axios.post(`${API}/surveys/${id}/raffle`, { force }).then(r => r.data),
  analyzeSurvey: (id) => axios.post(`${API}/surveys/${id}/ai-analysis`, {}, { timeout: 180000 }).then(r => r.data),

  getPopups: () => axios.get(`${API}/popups`).then(r => r.data),
  createPopup: (data) => axios.post(`${API}/popups`, data).then(r => r.data),
  updatePopup: (id, data) => axios.patch(`${API}/popups/${id}`, data).then(r => r.data),
  deletePopup: (id) => axios.delete(`${API}/popups/${id}`).then(r => r.data),
  getActivePopups: () => axios.get(`${API}/popups/active`).then(r => r.data),
  dismissPopup: (id) => axios.post(`${API}/popups/${id}/dismiss`).then(r => r.data),
};
